import React from 'react'
import {ActionSheet, ActionSheetButton, Modal} from 'react-onsenui'
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router-dom";
import {showToastMessage} from "../../../modules/toast";
import {showAlertMessage} from "../../../modules/alert";
import {DEFAULT_GPS_LOCATION, ENCODE_QUERY_DATA, GEO_LOCATION, GET_JOSA, NAVER_THUMBNAIL_GETTER} from "../../../modules/variable/common_variable";
import {useCurrentLocation} from "../../../modules/native";
import NavigationActionSheet from './navigationActionSheet';

class TrafficConditionActionSheet extends React.Component {
    state = {
        gpsFrom: null,
        list: [],
        trafficConditionActionSheet: {
            open: false,
            isLoading: false,
            list: [],
            parameters: {}
        },
        iframeActionSheet: {open: false, frameUrl: null},
        targetNaverPlaceActionSheet: {
            targetMarker: null,
            open: false,
            isLoading: false,
            data: null,
            chosenThumbnailType: 'map'
        },
        navigationSelectorActionSheet: {open: false, target: null},
    };

    componentDidMount() {
        const list = this.getDistance(this.props.list);
        const gpsFrom = this.getDistanceFromGps(this.props.list);
        this.setState({list: list, gpsFrom: gpsFrom});
    }

    componentWillReceiveProps(nextProps){
        if(this.props.usedCurrentLocation === true && nextProps.usedCurrentLocation === false){
            localStorage.setItem('savedGpsLocation', JSON.stringify(nextProps.currentLocation));
            const gpsFrom = this.getDistanceFromGps(this.props.list);
            this.setState({gpsFrom: gpsFrom});
        }
    }

    getDistance = (list) => {
        for(let i = 0; i <list.length; i ++){
            if(i !== 0 ){
                let distanceFrom = '0km';
                try {
                    let d = GEO_LOCATION.getDistance({latitude: list[i-1].y, longitude: list[i-1].x},{latitude: list[i].y, longitude: list[i].x});
                    if(d < 1){
                        distanceFrom = parseInt(d * 1000) + 'm';
                    }else{
                        distanceFrom = d.toFixed(1) + 'km'
                    }
                } catch (e) {
                    console.error(e);
                }
                list[i].distanceFrom = distanceFrom;
            }else{
                list[i].distanceFrom = null;
            }
        }
        return list;
    };

    getDistanceFromGps = (list) => {
        const savedGpsLocation  = localStorage.getItem('savedGpsLocation');
        let gpsLocation = DEFAULT_GPS_LOCATION;
        if(savedGpsLocation){
            try {
                gpsLocation = JSON.parse(savedGpsLocation);
            } catch (e) {
                console.error(e);
            }
        }

        //get distance from gps location with first && last
        let gpsFrom = null;
        if(list.length !== 0){
            let start = GEO_LOCATION.getDistance({latitude: gpsLocation.lat, longitude: gpsLocation.lng},{latitude: list[0].y, longitude: list[0].x});
            if(start < 1){start = parseInt(start * 1000) + 'm';}else{start = start.toFixed(1) + 'km'}
            let last = GEO_LOCATION.getDistance({latitude: gpsLocation.lat, longitude: gpsLocation.lng},{latitude: list[list.length - 1].y, longitude: list[list.length - 1].x});
            if(last < 1){last = parseInt(last * 1000) + 'm';}else{last = last.toFixed(1) + 'km'}
            gpsFrom = {start: start, last: last, hasGps: savedGpsLocation !== null};
        }
        return gpsFrom;
    };

    requestCurrentLocation = () => {
        if(window.isRNWebView === true || window.isRNWebView === 'true'){
            const message = JSON.stringify({'type': 'REQUEST_CURRENT_LOCATION'});
            window.postMessage(message, "*");
        }else{
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition((position) => {
                    const gpsLocation = {y: position.coords.latitude, x: position.coords.longitude, lat: position.coords.latitude, lng: position.coords.longitude};
                    localStorage.setItem('savedGpsLocation', JSON.stringify(gpsLocation));

                    const gpsFrom = this.getDistanceFromGps(this.props.list);
                    this.setState({gpsFrom: gpsFrom});
                }, (error) => {
                    if(window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf('192.168.') !== -1 ){
                        const testGpsLocation = {y: DEFAULT_GPS_LOCATION.lat, x: DEFAULT_GPS_LOCATION.lng, lat: DEFAULT_GPS_LOCATION.lat, lng: DEFAULT_GPS_LOCATION.lng};
                        localStorage.setItem('savedGpsLocation', JSON.stringify(testGpsLocation));

                        const gpsFrom = this.getDistanceFromGps(this.props.list);
                        this.setState({gpsFrom: gpsFrom});
                    }else{
                        console.error(error);
                        this.props.showToastMessage('위치 정보를 확인하는 과정에서 오류가 발생하였습니다.');
                    }
                }, {
                    enableHighAccuracy: false,
                    maximumAge: 0,
                    timeout: Infinity
                });
            } else {
                this.props.showToastMessage('본 기기가 GPS를 지원하지 않습니다.');
            }
        }
    };

    showTrafficCondition = () => {
        const sl = this.state.list;
        const savedGpsLocation = localStorage.getItem('savedGpsLocation');
        let gpsLocation = DEFAULT_GPS_LOCATION;
        if (savedGpsLocation) {
            try {
                gpsLocation = JSON.parse(savedGpsLocation);
            } catch (e) {
                console.error(e);
            }
        }

        let list = [];
        let prefix = 'https://m.map.naver.com/directions/?';

        for (let i = 0; i < sl.length; i++) {
            if (i === 0) {
                let route = '내위치' + ' → ' + sl[0].name;
                let query = {menu: 'route', sy: gpsLocation.y, sx: gpsLocation.x, sname: '내위치', ey: sl[i].y, ex: sl[i].x, ename: sl[i].name, pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }

            if (i !== 0) {
                let route = sl[i - 1].name + ' → ' + sl[i].name;
                let query = {menu: 'route', sy: sl[i - 1].y, sx: sl[i - 1].x, sname: sl[i - 1].name, ey: sl[i].y, ex: sl[i].x, ename: sl[i].name, pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }

            if (i === sl.length - 1) {
                let route = sl[sl.length - 1].name + ' → ' + '내위치';
                let query = {menu: 'route', sy: sl[i].y, sx: sl[i].x, sname: sl[i].name, ey: gpsLocation.y, ex: gpsLocation.x, ename: '내위치', pathType: 0};
                list.push({route: route, url: prefix + ENCODE_QUERY_DATA(query)});
            }
        }

        this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, list: list, open: true}});
    };

    chooseNaverPlace = (marker) => {
        this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, targetMarker: marker, open: true, isLoading: false, data: null}});
    };

    openNavigationSelector = (target) => {
        this.setState({navigationSelectorActionSheet: {...this.state.navigationSelectorActionSheet, open: true, target: target}})
    };

    render() {
        const list = this.state.list;
        const TNPAS = this.state.targetNaverPlaceActionSheet;
        const NSAS = this.state.navigationSelectorActionSheet;

        return (
            <div>
                <ActionSheet className="create-plan-expected-plan-action-sheet" isOpen={true} animation='default' modifier={'material'} onCancel={() => this.props.hide()} isCancelable={true}>
                    <div className="action-sheet-title action-sheet-title--material">
                        교통
                    </div>
                    <ul className="list list--material expected-plan-list">
                        {
                            list.map((e, i) => {
                                return (
                                    <li key={['expected', 'plan', e.id, i].join('_')} className="list-item list-item--material" style={{paddingLeft: '10px'}}>
                                        <div className="list-item__left list-item--material__left" onClick={() => this.chooseNaverPlace(e)} >
                                            <img className="list-item__thumbnail" src={NAVER_THUMBNAIL_GETTER(e)} onError={(e)=>{e.target.src = "https://fakeimg.pl/100x100/?text=No Image"}} alt={e.name}/>
                                        </div>
                                        <div className="list-item__center list-item--material__center" onClick={() => this.chooseNaverPlace(e)} >
                                            <div className="list-item__title list-item--material__title">
                                                {i + 1}. {e.name}
                                                &nbsp;
                                                {
                                                    e.distanceFrom ?
                                                        <small>
                                                            <i className="fa fa-arrows-alt-h"/> {e.distanceFrom}
                                                        </small>
                                                        :
                                                        null
                                                }
                                            </div>
                                            <div className="list-item__subtitle list-item--material__subtitle">
                                                {
                                                    e.address ?
                                                        <small>{e.address}</small>
                                                        :
                                                        null
                                                }
                                            </div>
                                        </div>
                                        <div className="list-item__right list-item--material__right">
                                            {/*{
                                                window.isRNWebView === true || window.isRNWebView === 'true' ?
                                                    <button className="fab fab--mini car-navigation" onClick={() => window.open("nmap://navigation?dlat=" + e.y + "&dlng=" + e.x + "&dname=" + encodeURIComponent(e.name) + "&appname=com.hopse.picnici")}>
                                                        <i className="fa fa-car"/>
                                                    </button>
                                                    :
                                                    <span className={['notification', 'notification--material', 'notification-category'].join(' ')}>{e.category ?  e.category.split(',').join(', ') : '없음'}</span>
                                            }*/}

                                            {/*{
                                                window.isRNWebView === true || window.isRNWebView === 'true' ?
                                                    <button className="fab fab--mini car-navigation" onClick={() => this.openNavigationSelector(e)}>
                                                        <i className="fa fa-car"/>
                                                    </button>
                                                    :
                                                    <span className={['notification', 'notification--material', 'notification-category'].join(' ')}>{e.category ?  e.category.split(',').join(', ') : '없음'}</span>
                                            }*/}
                                            <button className="fab fab--mini car-navigation" onClick={() => this.openNavigationSelector(e)}>
                                                <i className="fa fa-car"/>
                                            </button>
                                        </div>
                                    </li>
                                )
                            })
                        }
                    </ul>
                    {
                        list.length !== 0 ?
                            <ul className="list list--material create-plan-naver-place-save-schedule-wrapper">
                                {
                                    this.state.gpsFrom ?
                                        <li className="list-item list-item--material create-plan-naver-place-save-schedule-distance">
                                            <div className="list-item__center">
                                                <div className="list-item__title">
                                                    내 위치와의 거리
                                                    <button className="button--quiet create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                                        <i className="ion ion-android-locate"/>
                                                    </button>
                                                </div>
                                                {
                                                    this.state.gpsFrom.hasGps ?
                                                        <div className="list-item__subtitle">
                                                            <p><small>내 위치로부터 시작점인 </small>{list[0].name}<small>{GET_JOSA(list[0].name, '과')}</small> {this.state.gpsFrom.start}</p>
                                                            <p><small>내 위치로부터 도착점인 </small>{list[list.length - 1].name}<small>{GET_JOSA(list[list.length - 1].name, '과')}</small> {this.state.gpsFrom.last}</p>
                                                        </div>
                                                        :
                                                        <div className="list-item__subtitle">
                                                            <p>
                                                                <small>가져온 GPS 정보가 없습니다.</small>
                                                                &nbsp;
                                                                <small>GPS 정보 가져오기 →</small>
                                                                <button className="button--quiet create-plan-map-current-button" onClick={this.requestCurrentLocation}>
                                                                    <i className="ion ion-android-locate"/>
                                                                </button>
                                                            </p>
                                                        </div>
                                                }
                                            </div>
                                        </li>
                                        :
                                        null
                                }
                                <li className="list-item list-item--material text-center create-plan-naver-place-save-schedule-button-wrapper">
                                    <button className="button button--material" onClick={this.showTrafficCondition}><i className="fa fa-road"/> 경로</button>
                                </li>
                            </ul>
                            :
                            <ul className="list list--material create-plan-naver-place-save-schedule-wrapper"><li></li></ul>
                    }
                    <ActionSheetButton className="action-sheet-close TUTO_CLOSE_TRAFFIC_CONDITION_BUTTON" onClick={() => this.props.hide()} icon={'md-close'} modifier={'material'}>교통 닫기</ActionSheetButton>
                </ActionSheet>

                {
                    this.state.trafficConditionActionSheet.open ?
                        <ActionSheet className="traffic-condition-action-sheet" isOpen={this.state.trafficConditionActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, open: false}})} isCancelable={true}>
                            <div className="action-sheet-title action-sheet-title--material">
                                경로
                            </div>
                            <ul className="list list--material traffic-condition-list">
                                {
                                    this.state.trafficConditionActionSheet.list.map((e, i) => {
                                        return (
                                            <li key={['traffic', 'condition', i].join('_')} className="list-item list-item--material" onClick={() => this.setState({iframeActionSheet: {open: true, frameUrl: e.url}})}>
                                                <div className="list-item__center list-item--material__center">
                                                    <div className="list-item__title list-item--material__title">{e.route}</div>
                                                </div>
                                                <div className="list-item__right list-item--material__right">
                                                    <button className="fab fab--mini route-button"><i className="fa fa-directions"></i></button>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({trafficConditionActionSheet: {...this.state.trafficConditionActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>경로 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

                {
                    this.state.iframeActionSheet.open ?
                        <ActionSheet className="iframe-action-sheet" isOpen={this.state.iframeActionSheet.open} animation='default' modifier={'material'} onCancel={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} isCancelable={true} title={'이하 정보는 네이버 사이트입니다.'}>
                            <iframe id="iframe-action-sheet" title="iframe-action-sheet" src={this.state.iframeActionSheet.frameUrl}></iframe>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({iframeActionSheet: {...this.state.iframeActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

                {
                    TNPAS.open ?
                        <ActionSheet className="naver-place-only-action-sheet" isOpen={TNPAS.open} animation='default' modifier={'material'} onCancel={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, open: false}})} isCancelable={true}>
                            <div className="action-sheet-title action-sheet-title--material naver-place-only-action-sheet-title">{TNPAS.targetMarker ? TNPAS.targetMarker.name : null} <small>(사이트: 네이버 플레이스)</small></div>
                            <div className="card card--material">
                                <iframe title="naver-place-only-action-sheet" src={TNPAS.open ? 'https://m.store.naver.com/attractions/detail?id=' + TNPAS.targetMarker.id + '&back=false' : null}/>
                            </div>
                            <ActionSheetButton className="action-sheet-close" onClick={() => this.setState({targetNaverPlaceActionSheet: {...this.state.targetNaverPlaceActionSheet, open: false}})} icon={'md-close'} modifier={'material'}>사이트 닫기</ActionSheetButton>
                        </ActionSheet>
                        :
                        null
                }

                {
                    NSAS.open ?
                        <NavigationActionSheet NSAS={NSAS} hide={() => this.setState({navigationSelectorActionSheet: {...this.state.navigationSelectorActionSheet, open: false}})}/>
                        :
                        null
                }
            </div>
            )
    }
}

const mapStateToProps = ({ user, native }) => ({
    userInfo: user.userInfo,
    usedCurrentLocation: native.usedCurrentLocation,
    currentLocation: native.currentLocation,
});

const mapDispatchToProps = dispatch => ({
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
    showToastMessage: message => dispatch(showToastMessage(message)),
    useCurrentLocation: () => dispatch(useCurrentLocation()),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(TrafficConditionActionSheet))

